import React from 'react';
import classnames from 'classnames';
import Checkbox from 'components/Checkbox';
import { Filter, SubOption } from 'model/Filters';

const CSS = require('./FiltersBlock.less');

interface FiltersBlockProps {
  mainFilter: Filter | SubOption;
  subFilters: (Filter | SubOption)[];
  onMainFilterChange?: (e: any) => any;
  onSubFilterChange: (e: any) => any;
  isMainFilterSelected?: boolean;
  selectedSubFilters: SubOption[];
}

function FiltersBlock({ mainFilter, subFilters, onMainFilterChange, onSubFilterChange, isMainFilterSelected, selectedSubFilters = [] }: FiltersBlockProps) {
  return (
    <div>
      {
        onMainFilterChange &&
          <Checkbox
            className={CSS.MainFilter}
            labelClassName={CSS.MainFilterLabel}
            checked={isMainFilterSelected}
            onChange={onMainFilterChange}
            value={mainFilter.value}
            indeterminate={!isMainFilterSelected && selectedSubFilters.length > 0 ? 1 : undefined}
          >
            {mainFilter.name}
          </Checkbox>
      }
      {
        !onMainFilterChange && <span className={CSS.MainFilter}>{mainFilter.name}</span>
      }
      <ul className={classnames({ [CSS.SubFilters]: !!onMainFilterChange })}>
        {subFilters.map((subFilter) => {
          return (
            <li key={subFilter.value}>
              <Checkbox
                className={CSS.Checkbox}
                value={subFilter.value}
                onChange={onSubFilterChange}
                checked={(isMainFilterSelected || selectedSubFilters.some(filter => filter.value === subFilter.value))}
              >
                {subFilter.name}
              </Checkbox>
            </li>
          );
        }
        )}
      </ul>
    </div>
  );
}

export default FiltersBlock;
